import { WAY_PAY_VOID } from "@shared-logic/payments";
import { Price, RangeDate } from "../price.interface";
import { BUSINESS_PARTICULARITIES_VOID } from "@shared-logic/business-particularities";

export const typeCoins = {
    USD: 'USD',
    ARS: 'ARS',
    ALL: 'ALL',
    NONE: '--',
};

//TIPO DE MONEDA: (TypeCoin)
export const typeCoin = {
    '--': "--",
    'ARS': '$',
    'USD': 'US$',
}

export const typeCoinsStr = {
    '--': "--",
    'ARS': 'Pesos',
    'USD': 'Dólares',
}

export const CREATION_TYPE_CONST = {
    '-1': '--',
    STANDARD: 1,
    CRAMDOWN: 2,
    ANOTHER_BROKER: 3,
};


export const RANGE_DATE_VOID: RangeDate = {
    startDate: '--',
    endDate: '--',
}

export const initialPrice: Price = {
    _id: 0,
    observations: {
        isFeatured: -1,
        isFixed: -1,
        isMessage: -1,
        message: '',
        isBussinesGravanz: -1,
        isPort: -1,
        buyer: -1,
    },
    status: -1,
    productName: -1,
    typeBusiness: -1,
    placeOfDelivery: {
        zone: -1,
        port: -1,
    },
    deliveryPeriod: RANGE_DATE_VOID,
    quality: -1,
    price: -1,
    typeCoin: '--',
    typeDolar: 1,
    wayPay: WAY_PAY_VOID,
    pesificacion: {
        startDate: '--',
        endDate: '--',
    },
    harvest: '--',
    priceId: 1,
    dataOfcreation: {
        nameOfcreator: '--',
        email: '--',
        teamOfcreator: {
            bossLastName: '--',
            bossName: '--',
            nroTeam: -1,
        },
        dateOfcreation: '--',
        hour: '--',
    },
    businessParticularities: BUSINESS_PARTICULARITIES_VOID,
    //qualityParticularities: 0,//QUALITY_PARTICULARITIES_VOID,
    grouperCode: 1,
    qualityIBM: -1,
    created_at: '',

    conditionType: 0,
    indicators: [],
    creationType: 1
};